import React from 'react';

export const hint = (
  <>
    You have edited this Page in several existing proposals.
    <br />
    Clicking the “Confirm” button will permanently overwrite
    <br />
    any changes in the proposals you check below.
  </>
);

export const CONTENT_PAGE_PREVIEW_PARAM_NAME = 'contentPagePreviewId';
